// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__hQC7u","rootSmall":"AddTileButton_rootSmall__yJFA9"};